import { useEffect } from "react";
import { useHistory, } from "react-router";
import loading from '../../assets/load.gif'
import * as rtc from "../WebRTC/Rtc"

let history
let once = true 
const Load = () => {
    history = useHistory();
    useEffect(() => {
        if (once){
            if (localStorage.getItem('IsGuest') === 'false'){
                rtc.StartPeerConnection(false)
            }else {
                setTimeout(() => {
                    rtc.StartPeerConnection(true)
                }, 4000)  
            }
        }
        once = false
    })
    return (
        <div style={{position:'absolute', left: '50%', top: '50%', width: '30%', height: '10%',
            backgroundSize: 'cover', transform: 'translate(-50%, -50%)'}}>

                <h3 style={{textAlign:'center', textShadow:'0px 0px 7px black', marginBottom:"10%"}}>LOADING...</h3>
                <img style={{width: '100%', boxShadow:'0px 0px 7px black'}} src={loading} />
        </div>
    )
}

export function PushHistory(path){
    history.push(path)
}

export default Load
